import { DeliveryCost } from './delivery-cost.model';

export const deliveryCostMock: DeliveryCost = {
  zipCode: '00000-000',
  address: 'R. Alvarenga Meireles - Bom Jesus - Curitiba - Paraná',
  totalValue: 'R$ 27,80',
};
